import React, { Component } from 'react';
import CountUp from 'react-countup'
class TotalDownloads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myValue: this.props.value, // Replace this with your value from the backend or any other source
      scrolled: false,

    };
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  
  handleScroll = () => {
    // Logic to handle the scroll event
    // For example, check the scroll position and trigger actions accordingly
    const scrolled = window.scrollY > 0;
    this.setState({ scrolled });
  };

  render() {
    return (
      
        <div className="totalhitsbox">
          <p>Total Downloads</p>
        <div onScroll={this.handleScroll} className="totalhitsvalue-container"><CountUp start={0} end={this.props.value} duration={10} suffix="  +"/></div>
        </div>
      
    );
  }
}

export default TotalDownloads;
